import {defaultDataIdFromObject, StoreObject} from '@apollo/client';

import dataIdFromInaccessibleInfoObject from 'graphql-client/dataIdFromInaccessibleInfoObject';
import dataIdFromRunObject from 'graphql-client/dataIdFromRunObject';
import dataIdFromAnalyticsObject from 'insights/graphql-client/dataIdFromAnalyticsObject';

/**
 * Return Apollo cache identifier for Benchling objects
 *
 * To override, write a module-specific dataIdFromObject implementation and add it here. It should return the
 * custom identifier for objects it overrides, or undefined otherwise.
 *
 * This is deprecated in Apollo 3 and could be removed in future versions of Apollo.
 * @deprecated
 */
export default function dataIdFromBenchlingObject(responseObject: Readonly<StoreObject>): string | undefined {
  return (
    dataIdFromAnalyticsObject(responseObject) ||
    dataIdFromRunObject(responseObject) ||
    dataIdFromInaccessibleInfoObject(responseObject) ||
    defaultDataIdFromObject(responseObject)
  );
}
